import { projects } from "../../db/db";

import ProjectCard from "../ProjectCard";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";

import { ProjectsContent, StyledProjectsSection } from "./styles";

import { useEffect, useState } from "react";

function ProjectsSection() {
  const [windowSize, setWindowSize] = useState(getWindowSize());

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <StyledProjectsSection name="projects">
      <h1>
        <span className="icon">{">"}</span> Meus projetos
      </h1>
      <ProjectsContent>
        {projects.map((proj) => {
            return <ProjectCard proj={proj} />;
          })}
        {/* {windowSize.innerWidth > 600 ? (
          projects.map((proj) => {
            return <ProjectCard proj={proj} />;
          })
        ) : (
          <Swiper
            slidesPerView={1}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              600: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
            }}
            navigation={true}
            modules={[Pagination, Navigation]}
            className="mySwiper"
          >
            {projects?.map((proj) => {
              return (
                <>
                  <SwiperSlide key={proj.id}>
                    <ProjectCard proj={proj} />
                  </SwiperSlide>
                </>
              );
            })}
          </Swiper>
        )} */}
      </ProjectsContent>
    </StyledProjectsSection>
  );
}

export default ProjectsSection;
